export default "__VITE_ASSET__BPvzIPOb__"